import copy from "copy-to-clipboard";

const ua =
  typeof navigator === "object" ? navigator.userAgent.toLocaleLowerCase() : "";
const uaMsg = {
  isWhere: reg => {
    return ua.match(reg);
  },
  weixin: ua.match(/micromessenger/gi),
  isWeibo: ua.match(/weibo/i),
  QQ: ua.match(/qq\//),
  isAndroid: ua.match(/android/gi),
  isIos: ua.match(/iphone|ipod/gi),
  isIpad: ua.match(/ipad/gi),
  wxosEdition: () => {
    const reg = /([1-9]?[0-9])_([0-9])/gi;
    const iosarr = reg.exec(ua);

    if (iosarr != null && (this.isIos || this.isIpad) && iosarr.length >= 3) {
      return iosarr[1];
    } else {
      return 0;
    }
  }
};

const platForm = () => {
  if (uaMsg.weixin) {
    return "inter|wx_";
  } else if (uaMsg.QQ) {
    return "inter|qq_";
  } else if (uaMsg.isWeibo) {
    return "inter|wb_";
  } else {
    return "inter|other_";
  }
};

const oToS = (p, noPrefixKind) => {
  const arr = [];

  for (const n of Object.keys(p)) {
    if (!p[n]) continue;
    if (n === "secretCallUp" || n === "gourl" || n === "noPrefixKind") continue;
    if (n === "kind") {
      if (noPrefixKind) {
        arr.push(`${n}=${p[n]}`);
      } else {
        arr.push(`${n}=${platForm()}${p[n]}`);
      }
    } else {
      arr.push(`${n}=${p[n]}`);
    }
  }

  return arr.join("&");
};

let isFirstEntry = true;
const isCloseGuideFixed = () => {
  if (location.href.indexOf("weiboGuideFixed=1") === -1) {
    location.href = `${location.href}#weiboGuideFixed=1`;
  }
  const guideFixed = document.querySelector("#guideFixed");

  guideFixed.addEventListener("click", () => {
    if (location.href.indexOf("weiboGuideFixed=1") !== -1 && guideFixed) {
      history.back();
    }
  });
  if (isFirstEntry) {
    isFirstEntry = false;
    window.addEventListener("hashchange", () => {
      const guideChangeFixed = document.querySelector("#guideFixed");

      if (
        location.href.indexOf("weiboGuideFixed=1") === -1 &&
        guideChangeFixed
      ) {
        guideChangeFixed.parentNode.removeChild(guideChangeFixed);
      }
    });
  }
};

const callNewsAPP = (base, params) => {
  const coldCall = document.createElement("img");
  const coldCallId = `${decodeURIComponent(params.id)}&${oToS({
    kind: params.kind
  })}`;

  coldCall.src = `http://api.iclient.ifeng.com/shareArticle?type=${
    params.type
  }&id=${encodeURIComponent(coldCallId)}`;

  coldCall.id = "coldImg";
  coldCall.style.display = "none";
  document.body.appendChild(coldCall);

  setTimeout(() => {
    document.body.removeChild(coldCall);
  }, 500);

  const openPath = `wakeupiOS/${base.openPath || "ifengnews"}`;
  const download =
    base.download ||
    "http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1367873683475";
  const downloadAd = base.downloadAd || "";
  const ucStopover =
    base.ucStopover ||
    "http://x0.ifengimg.com/cmpp/2019/1015/ucStopover_v1.html?";
  const protocolApi = base.protocolApi || "comifengnewsclient://call";
  const domainApi = base.domainApi || "https://i.ifeng.com/";
  const noPrefixKind = params.noPrefixKind || "";

  let noDown = null;

  if (base.downloadAd && base.download) {
    noDown = true;
  }
  const paramsPath =
    typeof params === "object" ? `?${oToS(params, noPrefixKind)}` : "";

  let url = "";

  // 微博逻辑特殊处理
  if (uaMsg.isWeibo) {
    setTimeout(() => {
      if (!document.hidden) {
        document
          .querySelector("body")
          .insertAdjacentHTML(
            "beforeend",
            '<section id="guideFixed" style="position: fixed;width: 100%;height: 100%;top: 0; left: 0;background: #ececec; z-index:99999;"><img style="width:100%" src ="http://p2.ifengimg.com/ifengimcp/pic/20190507/21ab0fc3fd400f8e387e_size58_w750_h1334.png"></secton>'
          );
      }

      isCloseGuideFixed();
    }, 500);

    return false;
  }
  /*
   *复制剪切板
   * */
  if (uaMsg.isIos || uaMsg.isIpad) {
    // let urls = '';

    if (params.secretCallUp && params.gourl) {
      if (storage.getSession("calluped")) {
        location.href = params.gourl;

        return false;
      }
      storage.setSession("calluped", 1);
      setTimeout(() => {
        location.href = `${domainApi}${openPath}/call${paramsPath}&gourl=${encodeURIComponent(
          params.gourl
        )}&remind=1`;
      }, 10);

      return false;
    }

    if (params.gourl) {
      location.href = `${domainApi}${openPath}/call${paramsPath}&gourl=${encodeURIComponent(
        params.gourl
      )}&remind=1`;

      return false;
    }

    if (uaMsg.weixin) {
      location.href = `${domainApi}${openPath}/call${paramsPath}&remind=1`;

      return false;
    }
    // 转发进入 非扫码进入
    if (uaMsg.QQ) {
      copy(protocolApi + paramsPath);
      location.href = `${domainApi}${openPath}/call${paramsPath}&remind=1`;

      return false;
    }

    if (
      (ua.indexOf("ucbrowser") > 0 || ua.indexOf("u;") > 0) &&
      ua.indexOf("baidubrowser") === -1
    ) {
      url = protocolApi + paramsPath;
      location.href = download;

      return false;
    } else {
      let paramsPaths = paramsPath.replace("?", "");

      // url = `${domainApi}${openPath}/call${paramsPath}`;
      // urls = `${domainApi}${openPath}/call${paramsPath}&remind=1`;
      url = `${domainApi}${openPath}/call${paramsPath}&remind=1`;
    }
    // location.href = url;

    setTimeout(() => {
      // location.href = urls;
      location.href = url;
    });
  } else {
    if (params.secretCallUp && params.gourl) {
      if (storage.getSession("calluped")) {
        location.href = params.gourl;

        return false;
      }
      storage.setSession("calluped", 1);
      location.href = protocolApi + paramsPath;

      setTimeout(() => {
        location.href = params.gourl;
      }, 1000);

      return false;
    }

    if (params.gourl) {
      location.href = protocolApi + paramsPath;

      setTimeout(() => {
        location.href = params.gourl;
      }, 1000);

      return false;
    }
    if (uaMsg.weixin || uaMsg.QQ) {
      copy(protocolApi + paramsPath);
      url = `${download}&android_scheme=${encodeURIComponent(
        protocolApi + paramsPath
      )}`;
      location.href = url;

      return false;
    } else if (
      (ua.indexOf("ucbrowser") > 0 || ua.indexOf("u;") > 0) &&
      ua.indexOf("miuibrowser") === -1 &&
      ua.indexOf("vivobrowser") === -1 &&
      ua.indexOf("mqqbrowser") === -1
    ) {
      url = ucStopover + protocolApi + paramsPath;
    } else {
      url = protocolApi + paramsPath;
    }
    location.href = url;

    if (document.hasFocus() && noDown) {
      setTimeout(() => {
        location.href = downloadAd;
      }, 150);
    }
  }
};

module.exports = callNewsAPP;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.pullup/app/lib/callNewsAPP.js